export const mockData = {
  testimonials: [
    {
      id: 1,
      stars: 5,
      quote: "Avant NeoNkawa, j'étais stressé à chaque turnover. Maintenant je dors tranquille. Ma note est passée de 4.7 à 4.9.",
      name: "Hassan",
      badge: "Superhost 3 appartements, Hamria",
      avatar: "https://ui-avatars.com/api/?name=Hassan&background=0099FF&color=fff&size=128"
    },
    {
      id: 2,
      stars: 5,
      quote: "Les photos après chaque nettoyage = game changer. Je n'ai plus besoin de me déplacer pour vérifier.",
      name: "Fatima",
      badge: "Superhost 2 appartements, Ville Nouvelle",
      avatar: "https://ui-avatars.com/api/?name=Fatima&background=00C878&color=fff&size=128"
    },
    {
      id: 3,
      stars: 5,
      quote: "Service rapide et fiable. Ils ont sauvé mes fesses plusieurs fois avec des bookings last-minute.",
      name: "Karim",
      badge: "Host 1 appartement, Hamria",
      avatar: "https://ui-avatars.com/api/?name=Karim&background=0099FF&color=fff&size=128"
    }
  ],
  services: [
    {
      id: 1,
      icon: "home",
      title: "Airbnb Express",
      description: "Nettoyage après checkout",
      price: "À partir de 120 DH",
      featured: false
    },
    {
      id: 2,
      icon: "package",
      title: "Abonnement 8×",
      description: "8 nettoyages/mois",
      price: "1,200 DH (150 DH/cleaning)",
      featured: true
    },
    {
      id: 3,
      icon: "zap",
      title: "Service Urgence",
      description: "Intervention <4h",
      price: "180 DH",
      featured: false
    }
  ],
  stats: [
    { number: "200+", label: "Nettoyages Complétés" },
    { number: "98%", label: "Clients Satisfaits" },
    { number: "4.9★", label: "Note Moyenne" },
    { number: "<15min", label: "Temps de Réponse" }
  ],
  faq: [
    {
      id: 1,
      question: "Vous intervenez le weekend?",
      answer: "Oui, 7j/7 y compris weekends et jours fériés."
    },
    {
      id: 2,
      question: "Combien de temps prend un nettoyage?",
      answer: "2-3 heures pour un appartement 2 chambres standard."
    },
    {
      id: 3,
      question: "Comment je paie?",
      answer: "Virement, cash ou mobile money. Facture fournie."
    },
    {
      id: 4,
      question: "Vous fournissez les produits?",
      answer: "Oui, tous les produits et équipements sont inclus dans le tarif."
    },
    {
      id: 5,
      question: "Que se passe-t-il si je ne suis pas satisfait?",
      answer: "Garantie re-cleaning gratuit dans les 24h ou remboursement 100%."
    }
  ],
  contact: {
    phone: "+212 653555855",
    location: "Meknès, Maroc",
    whatsappLink: "https://wa.me/212653555855"
  }
};